<dhp-filter-accordion [filterName]="filterName()">
  <dhp-filter-date-range (dateRangeOutput)="dateRangeOutput.emit($event)" />
</dhp-filter-accordion>
